"use client";
import "../../../chunk-MMUBH76A.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { Heading, HeroIcon, InnerStepContainer, StepContainer } from "../common.js";
import { useModalStore, useThemeStore } from "../../stores/index.js";
import { useMemo } from "react";
import { CpslButton, CpslText } from "@getpara/react-components";
import { getAddFundsStep } from "../../utils/steps.js";
const AddFundsDone = ({ isSuccess, onClose }) => {
  const hideWallets = useThemeStore((state) => state.hideWallets);
  const setStep = useModalStore((state) => state.setStep);
  const onRampPurchase = useModalStore((state) => state.onRampPurchase);
  const accountAddFundTab = useModalStore((state) => state.accountAddFundTab);
  const formatter = useMemo(() => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: (onRampPurchase == null ? void 0 : onRampPurchase.fiat) || "USD"
    });
  }, [onRampPurchase == null ? void 0 : onRampPurchase.fiat]);
  const heading = isSuccess ? "Transaction Successful" : "Something Went Wrong";
  const text = isSuccess ? `${formatter.format(parseFloat(onRampPurchase == null ? void 0 : onRampPurchase.fiatQuantity))} is now available in your ${hideWallets ? "account" : "wallet"}.` : `No funds were added to your ${hideWallets ? "account" : "wallet"}.`;
  const buttonText = isSuccess ? "Done" : "Try Again";
  return /* @__PURE__ */ jsxs(StepContainer, { children: [
    /* @__PURE__ */ jsx(HeroIcon, { icon: "checkCircleFilled" }),
    /* @__PURE__ */ jsxs(InnerStepContainer, { children: [
      /* @__PURE__ */ jsx(Heading, { variant: "headingS", weight: "bold", children: heading }),
      /* @__PURE__ */ jsx(CpslText, { variant: "bodyS", color: "secondary", children: text })
    ] }),
    /* @__PURE__ */ jsx(
      CpslButton,
      {
        fullWidth: true,
        onClick: () => {
          isSuccess ? onClose() : setStep(getAddFundsStep(accountAddFundTab));
        },
        children: buttonText
      }
    )
  ] });
};
export {
  AddFundsDone
};
